import styled from "@emotion/styled";
import { MDSRowItemSize } from "./row-item.types";
import { mdsPanelWidthsValue } from "@/design-system/foundations";

export const StyledRowItem = styled.div<{
  $size: MDSRowItemSize;
  $hasSuggestion: boolean | undefined;
  $mustClickOnRowTitle: boolean;
  $isSelected: boolean | undefined;
  $isHighlighted: boolean | undefined;
  $isSpecial: boolean | undefined;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding-inline: ${({ theme }) => theme.spacing["7"]};
  padding-block: ${({ theme }) => theme.spacing["4"]};

  cursor: ${({ $mustClickOnRowTitle }) => ($mustClickOnRowTitle ? "default" : "pointer")};
  ${({ $size }) => rowSizeStyleMapping[$size]}
  background-color: ${({ theme }) => theme.colors.background.list.default};
  ${({ $hasSuggestion, theme }) =>
    $hasSuggestion && `background-color: ${theme.colors.background.diff};`}

  border-radius: 0;

  ${({ $isSpecial, theme }) =>
    $isSpecial &&
    `
    background-color: ${theme.colors.background.list.deepsearch};
    animation-name: specialFadeIn;
    animation-duration: 2200ms;
    animation-timing-function: ease-in;
    animation-delay: 1s;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: forwards;
  `}
  ${({ $isSelected, theme }) =>
    $isSelected &&
    `
      background-color: ${theme.colors.background.list.selected};
      transition: 0.2s all;
    `}
  &:hover {
    background-color: ${({ theme }) => theme.colors.background.list.hover};
    transition: 0.2s all;
  }
  ${({ $isHighlighted, theme }) =>
    $isHighlighted &&
    `
      background-color: ${theme.colors.background.button.transparent.hover};
      transition: 0.2s all;
    `}

  user-select: none;

  @keyframes specialFadeIn {
    from {
      background-color: ${({ theme }) => theme.colors.background.list.selected};
    }
    to {
      background-color: transparent;
    }
  }

  container-type: inline-size;
  container-name: mds-row-item;

  @container mds-panel (max-width: ${mdsPanelWidthsValue.narrow}px) {
    padding-inline: ${({ theme }) => theme.spacing["4"]};
  }
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: row;
  line-height: ${({ theme }) => theme.fontSizes.medium};
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: ${({ theme }) => theme.spacing.xs};
`;

const rowSizeStyleMapping: { [key in MDSRowItemSize]: string } = {
  [MDSRowItemSize.Medium]: `height: 48px;`,
  [MDSRowItemSize.Large]: `height: 56px;`,
  [MDSRowItemSize.XLarge]: `min-height: 60px;`,
  [MDSRowItemSize.Full]: `min-height: 60px;`,
};

export const StyledRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["1"]};
  flex: 1;
  height: 100%;
  overflow: hidden;
  flex: 1 1 0%;
`;

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  flex: 1 1 0%;
`;

export const StyledRowSeparator = styled.div`
  /* Hack to put it over the row item so it looks like the height is the same. */
  margin: ${({ theme }) => `-1px ${theme.spacing["7"]} 0 ${theme.spacing["7"]}`};
  background-color: ${({ theme }) => theme.colors.border.default};
  height: 1px;
  width: calc(100% - 2 * ${({ theme }) => theme.spacing["7"]});
`;
